import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navigation } from "@/components/sections/Navigation";
import { Hero } from "@/components/sections/Hero";
import { FeaturedProducts } from "@/components/sections/FeaturedProducts";
import { ReviveStory } from "@/components/sections/ReviveStory";
import { WhyUs } from "@/components/sections/WhyUs";
import { ComingSoon } from "@/components/sections/ComingSoon";
import { Testimonials } from "@/components/sections/Testimonials";
import { ContactFooter } from "@/components/sections/ContactFooter";
import ThankYou from "@/components/pages/ThankYou";
import Cancelled from "@/components/pages/Cancelled";
import LogoStudio from "@/components/pages/LogoStudio";
import { FEATURES } from "@/config/features";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-bone text-ink min-h-screen">
      <Navigation />
      <Hero />
      <FeaturedProducts />
      {FEATURES.showRevive && <ReviveStory />}
      <WhyUs />
      <ComingSoon />
      <Testimonials />
      <ContactFooter />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/cancelled" element={<Cancelled />} />
          <Route path="/logo-studio" element={<LogoStudio />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
